export const WhatsAppContactConsultor =
  "https://api.whatsapp.com/send?phone=5521995771313&text=Quero%20falar%20com%20um%20consultor%20Strm";
